// eslint-disable-next-line @sail/data-no-imperative-methods
import {ApolloLink, Observable} from '@apollo/client';
import type {IApiErrorMetadata} from '@stripe-internal/connect-embedded-lib';
import {getStripeOrGraphQLErrorMetadata} from '@stripe-internal/connect-embedded-lib';
import {isInvalidOrExpiredSessionError} from '../../connect/EmbeddedInvalidOrExpiredSessionContext';

export function createDetectExpiredOrInvalidSessionLink(
  onSessionInvalidOrExpired: (error: IApiErrorMetadata) => void,
) {
  return new ApolloLink((operation, forward) => {
    return new Observable((observer) => {
      return forward(operation).subscribe({
        next(data) {
          if (data.errors) {
            data.errors.forEach((error) => {
              const errorMetadata = getStripeOrGraphQLErrorMetadata(error);

              if (
                isInvalidOrExpiredSessionError(errorMetadata.stripeStatusCode)
              ) {
                onSessionInvalidOrExpired(errorMetadata);
              }
            });
          }

          return observer.next(data);
        },

        error(error) {
          const errorMetadata = getStripeOrGraphQLErrorMetadata(error);

          if (isInvalidOrExpiredSessionError(errorMetadata.stripeStatusCode)) {
            onSessionInvalidOrExpired(errorMetadata);
          }

          observer.error(error);
        },

        complete() {
          observer.complete();
        },
      });
    });
  });
}
